var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Contato',{attrs:{"showMenu":_vm.showMenu,"origem":_vm.origem,"contactOnly":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }